{
  "name": "leaflet-shape-markers",
  "description": "Shape markers of fixed size for point symbols",
  "version": "1.0.6",
  "author": "Rachel Nehmer <rnehmer@esri.com>",
  "bugs": {
    "url": "https://github.com/Esri/Leaflet.shapeMarkers/issues"
  },
  "contributors": [
    "Rachel Nehmer <rnehmer@esri.com>",
    "John Gravois <jgravois@esri.com>"
  ],
  "dependencies": {
    "leaflet": "^1.0.0"
  },
  "devDependencies": {
    "karma": "^0.12.24",
    "karma-mocha": "^0.1.0",
    "karma-chai-sinon": "^0.1.3",
    "karma-coverage": "^0.5.3",
    "karma-mocha-reporter": "^0.2.5",
    "karma-phantomjs-launcher": "^0.2.0",
    "karma-sourcemap-loader": "^0.3.5",
    "semistandard": "^7.0.5",
    "gh-release": "^2.0.0",
    "mkdirp": "^0.5.1",
    "rollup": "^0.25.4",
    "rollup-plugin-json": "^2.0.0",
    "rollup-plugin-node-resolve": "^1.4.0",
    "rollup-plugin-uglify": "^0.3.1",
    "uglify-js": "^2.4.23",
    "watch": "^0.17.1"
  },
  "homepage": "http://github.com/Esri/Leaflet.shapeMarkers",
  "module": "src/ShapeMarkers.js",
  "jsnext:main": "src/ShapeMarkers.js",
  "jspm": {
    "registry": "npm",
    "format": "es6"
  },
  "keywords": ["Leaflet", "GIS", "Esri"],
  "license": "Apache-2.0",
  "main": "dist/leaflet-shape-markers.js",
  "readmeFilename": "README.md",
  "repository": {
    "type": "git",
    "url": "git@github.com:Esri/Leaflet.shapeMarkers.git"
  },
  "scripts": {
    "prepublish": "npm run build",
    "prebuild": "mkdirp dist",
    "build": "rollup -c scripts/debug.js && rollup -c scripts/production.js",
    "release": "./scripts/release.sh",
    "lint": "semistandard src/*.js",
    "pretest": "npm run build",
    "start": "watch 'npm run build' src & http-server -p 5000 -c-1 -o",
    "test": "npm run lint && karma start"
  }
}
